import api from '@/api'
const state = {

}

const actions = {
  async updateUserInfo ({state}, payload) {
    const result = await api.homeApi.updateUserInfo(payload)
    return result
  },
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
